import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  contentBox: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '28px 16px',
      borderRadius: 24
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 12px',
      marginTop: 15,
      borderRadius: 20
    }
  },
  cardsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '32px 20px',
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      gap: '20px 12px',
      marginTop: -15
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: -20
    }
  },
  card: {
    flex: '0 1 calc(25% - 15px)',
    background: theme.palette.background.paper,
    borderRadius: 24,
    padding: '32px 60px',
    textAlign: 'center',
    boxShadow: '0px 4px 14px rgba(151, 149, 149, 0.04)',
    transition: '0.2s',
    [theme.breakpoints.up('xl')]: {
      flex: '0 1 calc(25% - 15px)',
      padding: '24px 56px'
    },
    [theme.breakpoints.down('md')]: {
      flex: '0 1 calc(25% - 15px)',
      padding: '24px 16px'
    },
    [theme.breakpoints.down('xs')]: {
      flex: '0 1 calc(50% - 10px)',
      padding: '24px 16px'
    }
  },
icon: {
  width: 'clamp(40px, 6vw, 65px)',
  height: 'clamp(40px, 6vw, 65px)',
  marginBottom: 10
},
  title: {
    fontWeight: 600,
    marginBottom: 16,
    color: theme.palette.secondary.dark
  },
  list: {
    textAlign: 'center'
  },
  listItem: {
    fontSize: '0.9rem',
    marginBottom: 8,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem'
    }
  }
}))
